<template>
    <div class="container heading">
        <div class="row">
            <div class="heading-header">
                <h2>BAR PASSAGE/ADMISSION REPORT</h2>
                <h6>SECTION OF LEGAL EDUCATION</h6>
            </div>
            <div class="singlesection">
                <h4>INDIVIDUAL SCHOOL BAR PASSAGE/ADMISSION REPORTS</h4>
            </div>
            <div class="singleyearinput">
                <span>Select the Year: </span>
                <select v-model="selectedYearSingle" class="form-select" aria-label="year select">
                    <option value="">Select Year</option>
                    <option v-for="year in years" :key="year" :value="year">{{ year }}</option>
                </select>
            </div>
            <div class="singleschoolinput">
                <span>Select the School: </span>

                <select v-if="selectedYearSingle" v-model="selectedSchoolSingle" class="form-select" aria-label="school select">
                    <option value="">Select School</option>
                    <option v-for="school in schools" :key="school" :value="school">{{ school }}</option>

                </select>
                <select v-else-if="!selectedYearSingle" v-model="selectedSchoolSingle" class="form-select" aria-label="school select">
                    <option value="">Select School</option>
                </select>
            </div>
            <div class="singlegeneratebtn">
                <button type="button" class="btn" @click="generateSingleReport">Generate Report</button>
            </div>
            <hr style="border: 1px solid black; margin-top: 1.5vw; margin-bottom:-1vw;">

            <div class="compsection">
                <h4>COMPILATION - ALL SCHOOLS DATA</h4>
            </div>
            <div class="compyearinput">
                <span>Select the Year: </span>
                <select v-model="selectedYearComp" class="form-select" aria-label="year select">
                    <option value="">Select Year</option>
                    <option v-for="year in years" :key="year" :value="year">{{ year }}</option>
                </select>
            </div>
            <div class="compSectioninput">
                <span>Select the Section: </span>
                <select v-if="selectedYearComp<=2024" v-model="selectedSectionComp" class="form-select" aria-label="section select">
                    <option value="">Select Section</option>
                    <option v-for="section in sections" :key="section" :value="section">{{ section }}</option>
                </select>
                <select v-else-if="selectedYearComp>=2025" v-model="selectedSectionComp" class="form-select" aria-label="section select">
                    <option value="">Select Section</option>
                    <option v-for="section in sections2025" :key="section" :value="section">{{ section }}</option>
                </select>
                <select v-else-if="!selectedYearComp" v-model="selectedSectionComp" class="form-select" aria-label="section select">
                    <option value="">Select Section</option>
                </select>
            </div>
            <div class="compbtn">
                <button type="button" class="btn" @click="generateCompReport">Generate Report</button>
            </div>
            <div class="note">
                <div class="icon" id="noteicon">
                    <img src="../assets/note.png" alt="Notification Icon" style="width:20px; height:20px" />
                </div>
                <h2>Notification</h2>
                <p>The data reported here are submitted by law schools to the ABA. The ABA assumes no responsibility for inaccuracies or for changes in such information that may occur after publication.</p>
                <p>Beginning in 2025, the titles for these 509 reports were updated to include “Bar Admission” language instead of the former “Bar Passage” language.</p>
            </div>
            <div v-if="loading" class="loading-overlay">
                <div class="spinner"></div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    export default {
        name: 'BarPassageOutcomes',
        data() {
            return {
                selectedYearSingle: '',
                selectedSchoolSingle: '',
                selectedYearComp: '',
                selectedSectionComp: '',
                years: [2025,2024, 2023, 2022, 2021, 2020, 2019, 2018],
                schools: [],
                schoolCodes: {},
                sections: ['First Time Bar Passage', 'Two-Year Ultimate Bar Passage'],
                sections2025: ['First Time Bar Admission', 'Two-Year Ultimate Bar Admission'],
                sectionIDs: {},
                loading: false,
                API_URL: process.env.VUE_APP_ROOT_API,
            };
        },
        watch: {
            async selectedYearSingle(newYear) {
                if (newYear) {

                    await this.fetchSchools();
                }
                this.selectedSchoolSingle = '';
            },
            selectedYearComp(newYear) {
            if (newYear) {
                this.resetSections();
            }
        },
    },
        methods: {
            async fetchSchools() {

                try {
                    const res = await axios.get(`${this.API_URL}Master/GetUniversityListByYear`, {
                        params: {
                            schoolYear: this.selectedYearSingle,
                        },
                    });
                    const universityList = res.data.universityListEntities;
                    this.schools = universityList.map(university => university.schoolName);
                    this.schoolCodes = universityList.reduce((acc, university) => {
                        acc[university.schoolName] = university.schoolCode;
                        return acc;
                    }, {});
                }
                catch (error) {
                    console.error('Error fetching data:', error);
                }
            },
            resetSections() {
            this.selectedSectionComp = '';
            },

            async generateSingleReport() {
                if (this.selectedYearSingle && this.selectedSchoolSingle) {
                    try {
                        this.loading = true;
                        const schoolCode = this.schoolCodes[this.selectedSchoolSingle];
                        const response = await axios.get(`${this.API_URL}BarPassageOutcomes/GenerateIndividualBarPassageReport`, {
                            params: {
                                schoolId: schoolCode,
                                year: this.selectedYearSingle,
                            },
                            responseType: 'blob',
                        });
                        const blob = new Blob([response.data], {
                            type: response.headers['content-type'],
                        });
                        const link = document.createElement('a');
                        link.href = window.URL.createObjectURL(blob);
                        const file_Name = `BarPassage_${this.selectedYearSingle}.pdf`;
                        link.download = file_Name;
                        link.click();
                        link.remove();
                    }
                    catch (error) {
                        console.error('Error generating single report:', error);
                        alert('An error occurred while generating the report. Please try again later.');
                    }
                    finally {
                        this.loading = false; // Stop loading
                    }
                }
                else {
                    alert('Please select both year and school.');
                }
            },
            async generateCompReport() {
                if (this.selectedYearComp && this.selectedSectionComp) {
                    try {
                        this.loading = true;
                        const response = await axios.get(`${this.API_URL}BarPassageOutcomes/GenerateBarPassageCompilationReport`, {
                            params: {
                                year: this.selectedYearComp,
                                sectionName: this.selectedSectionComp,
                            },
                            responseType: 'blob',
                        });
                        const blob = new Blob([response.data], {
                            type: response.headers['content-type'],
                        });
                        const link = document.createElement('a');
                        link.href = window.URL.createObjectURL(blob);
                        const sanitizedSectionName = this.selectedSectionComp.replace(/\s+/g, '_');
                        const file_name = `${sanitizedSectionName}_${this.selectedYearComp}.xlsx`;
                        link.download = file_name;
                        link.click();
                        link.remove();
                    }
                    catch (error) {
                        console.error('Error generating compilation report:', error);
                        alert('An error occurred while generating the report. Please try again later.');
                    }
                    finally {
                        this.loading = false; // Stop loading
                    }
                }
                else {
                    alert('Please select both year and section.');
                }
            },

        }
    }
</script>

<style scoped>
    .container {
        position: relative;
        color: black;
        height: 100%;
        padding-top: 1vw;
        padding-left: 2vw;
        font-family: Helvetica;
        font-weight: 700;
    }
</style>
